export default {
    loading: 'Loading CAPTCHA...',
    init: 'Initializing CAPTCHA...',
    click: 'Click the button to verify',
    checking: 'Detecting...',
    pass: 'Verification passed',
    tip: 'Error message',
    error: {
        try: 'Failed {num} times in a row. Please try again later.',
        init: 'Initialization error. Please try again later.'
    },
    move: 'Move the slider to complete verification',
    drag: 'Drag the left slider to complete the puzzle above',
    dragging: 'Drag the slider to align the floating image',
    close: 'Close verification',
    refresh: 'Refresh verification',
    feedback: 'Feedback & Support',
    provide: 'Powered by 「 makeit.vip 」',
    success: 'Completed image puzzle verification in {take}s',
    flatten: 'Drag the slider to align the image',
    verify: 'Verification successful'
}
